import TMap from "TMap";

const getPoint = (lat, lng) => {
    return new TMap.LatLng(lat, lng);
}

const getMap = (containerId, options) => {
    return new TMap.Map(containerId, options);
}

const getPointBMap = (coordinateString) => {

    const [ lat, lng ] = coordinateString.split(",");

    return [parseFloat(lng), parseFloat(lat)];
};

export default {
    getPoint,
    getMap,
    getPointBMap
};